import { EntityTableSimple, EntityTableSimpleProps, EntityTableSimpleReducers, EntityTableSimpleState, FieldDescriptor, Optional } from "@crispico/foundation-react";
import { ReduxReusableComponents } from "@crispico/foundation-react/reduxReusableComponents/ReduxReusableComponents";
import { CellProps } from "fixed-data-table-2";
import { Draggable, Droppable, Identifier } from "pages/gantt/DragAndDrop";
import { DragAndDropControllerNew } from "pages/gantt/DragAndDropControllerNew";

export type EntityTableSimpleDnDCellProps = EntityTableSimpleProps & {
    onDrop: (sources: any[], sourcesEntityType: Identifier, dest: any, destEntityType: Identifier) => void
}

export class EntityTableSimpleDnDCell extends EntityTableSimple<EntityTableSimpleDnDCellProps> {

    protected getCellContent({ rowIndex, columnKey }: CellProps, fieldDescriptorChain?: FieldDescriptor[]): Optional<{ fieldDescriptor?: Optional<FieldDescriptor>, content: any, entity?: any }> {
        const cellContent = super.getCellContent({ rowIndex, columnKey }, fieldDescriptorChain);
        return { ...cellContent, content: this.getDndContent(cellContent!.content, rowIndex!, columnKey!) };
    }

    protected getDndContent(content: any, rowIndex: number, columnKey: string | number) {
        let entity = this.getEntity(rowIndex);
        const key = this.props.entityDescriptor.name + '_' + columnKey + '_' + (entity?.id || rowIndex);
        return <Droppable className="Droppable" key={key} item={entity} type={this.props.entityDescriptor.name} accept={DragAndDropControllerNew.INSTANCE.getAcceptedType(this.props.entityDescriptor.name)} canDrop={DragAndDropControllerNew.INSTANCE.canDrop}
            drop={this.props.onDrop}>
            <Draggable className="Draggable" key={key} item={entity} type={this.props.entityDescriptor.name} canDrag={DragAndDropControllerNew.INSTANCE.canDrag} hideDragPreview={true}>
                {content}
            </Draggable>
        </Droppable>
    }
}

export const EntityTableSimpleDnDCellRRC = ReduxReusableComponents.connectRRC(EntityTableSimpleState, EntityTableSimpleReducers, EntityTableSimpleDnDCell);
